module.exports = __webpack_public_path__ + "static/img/xmgs.e679ea76.png";